import { render, staticRenderFns } from "./OrderCompleted.vue?vue&type=template&id=37cf1dd8&scoped=true&"
import script from "./OrderCompleted.vue?vue&type=script&lang=js&"
export * from "./OrderCompleted.vue?vue&type=script&lang=js&"
import style0 from "./OrderCompleted.vue?vue&type=style&index=0&id=37cf1dd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cf1dd8",
  null
  
)

export default component.exports